import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, TaxesService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { PoItemsRepository } from '../po-creation/repository/po-items.repository';
import { StockAdapter } from '../stock/dto/stock.adapter';
import { GrnAdapter } from './dto/grn.adapter';
import { GrnItems } from './grn-items.entity';
import { GrnController } from './grn.controller';
import { Grn } from './grn.entity';
import { GrnService } from './grn.service';
import { GrnRepository } from './repository/grn-repository';
import { StockRepository } from './repository/stock-repository';
import { PurchaseOrderService, StockService } from '@gtpl/shared-services/procurement';
import {AssetService} from '@gtpl/shared-services/asset-management';
import { PoCreationModule } from '../po-creation/po-creation.module';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { ScheduleModule } from '@nestjs/schedule';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast';
import { LogsService } from '@gtpl/shared-services/user-logs';


@Module({
  imports: [

    TypeOrmModule.forFeature([Grn, GrnItems, GrnRepository, PoItemsRepository, StockRepository]),
    PoCreationModule,
    ScheduleModule.forRoot(),

  ],
  controllers: [GrnController],
  // providers: [GrnService,ApplicationExceptionHandler,GrnAdapter,StockAdapter,ItemCategoryService,ItemsService,VendorsService,PoItemsRepository,SaleOrderService,PurchaseOrderService,SizesService,TaxesService,StockService,VendorsPriceListService, ItemSubCategoryService,WhatsAppNotificationService,WhatsappBroadCastService,LogsService]
  providers: [GrnService, ApplicationExceptionHandler, GrnAdapter, StockAdapter, ItemCategoryService, ItemsService, VendorsService, PoItemsRepository, SaleOrderService, PurchaseOrderService, SizesService, TaxesService,AssetService, StockService, VendorsPriceListService, ItemSubCategoryService, WhatsAppNotificationService, WhatsappBroadCastService, LogsService]
})
export class GrnModule { }
